namespace TerminalApp {
    export class Header {
        constructor() {
            document.getElementById("home_button").onclick = () => {
                GetApp("homescreen").open();
            }

            document.getElementById("home_button_2").onclick = () => {
                GetApp("homescreen").open();
            }

            document.getElementById("sign_out_button").onclick = () => {
                LogOut();
            }


            (document.querySelector(".find_placement_button") as HTMLElement).onclick = () => {
                placementFinderAssistant.open(null);
                //if (document.fullscreen)
                //    document.exitFullscreen();
                //else
                //    document.body.requestFullscreen();
            }
        }
    }
}